import ConnectERP from "./ConnectERP";
import ConnectEmedHub from "./ConnectEmedHub";

const Integrations = () => {
    return (
        <div className="p-4">
            <h1 className="text-2xl font-semibold mb-4">Integrations</h1>
            <p className="text-gray-600 dark:text-gray-300 mb-3">
                Manage your third-party integrations here. Connect to popular tools like Slack, Google Calendar, and more to streamline your HR processes.
            </p>

            <ConnectERP />
            <ConnectEmedHub />
        </div>
    );
};

export default Integrations;